import React from 'react';

const WorkingSteps = () => {
  return (
    <div 
      className="section-full p-t150 site-bg-white twm-w-steps-section-wrap wow fadeInDown" 
      data-wow-offset="100" 
      data-wow-delay="0.2" 
      style={{ backgroundImage: 'url(images/step-bg.jpg)' }}
    >
      <div className="container">

        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">How it Works</div>
          <h2 className="twm-large-title site-text-dark">Following Working Steps</h2>
        </div>
        {/* TITLE END */}
        
        <div className="section-content">
          <div className="row twm-w-steps-section">
            
            {/* Step 1 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>01</span>
                </div>
                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Choose A Car</h3>
                  <p>Check out our range of cars and choose the car of your choice</p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>02</span>
                </div>
                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Pick Up Date</h3>
                  <p>Choose your preferred pick-up date for the vehicle.</p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>03</span>
                </div>
                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Confirm Your Booking</h3>
                  <p>Review your details and confirm your booking for the car.</p>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>04</span>
                </div>
                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Enjoy Riding</h3>
                  <p>AB Ghule Cabs - Enjoy Your Riding Experience
</p>
                </div>
              </div>
            </div>

          </div>

          {/* Advertisement Section */}
          <div className="twm-adv-show">
            {/* <img src="images/adv-car.png" alt="Car Advertisement" /> */}
            <img src="images/orange-car.png" alt="Car Advertisement" />
          </div>

        </div>

      </div>
    </div>
  );
};

export default WorkingSteps;
